var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import MuiToggleButtonGroup, { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material/styles';
import React from 'react';
import { colorPalette } from '../../colorPalette';
import { ToggleButton } from '../ToggleButton';
import Divider from '@mui/material/Divider';
export const ToggleButtonGroup = (_a) => {
    var { toggleButtons } = _a, additionalProps = __rest(_a, ["toggleButtons"]);
    return (React.createElement(CustomToggleButtonGroup, Object.assign({}, additionalProps), toggleButtons.flatMap((toggleButton, index) => [
        React.createElement(ToggleButton, Object.assign({ key: index }, toggleButton)),
        index < toggleButtons.length - 1 && (React.createElement(Divider, { key: `divider-${index}`, orientation: "vertical", flexItem: true, sx: {
                border: '1px solid',
                borderColor: colorPalette.gray200,
                width: 0,
                marginLeft: '4px',
                marginRight: '5px',
            } })),
    ])));
};
const CustomToggleButtonGroup = styled(MuiToggleButtonGroup)(() => ({
    [`& .${toggleButtonGroupClasses.grouped}`]: {
        borderRadius: '8px',
        border: '2px solid transparent',
    },
    borderRadius: '8px',
    border: '1px solid',
    borderColor: colorPalette.gray300,
    padding: '4px',
}));
